export default "https://cdn-static.gokick.com/assets/b18addbf7a1bb69f1adff96c45455352533f108a/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";